import { AxiosResponse } from 'axios'
import { IApiSuccessResponse } from 'interfaces/api-success-response'
import { ICheckLockDate, ITabIdRequest } from 'interfaces/payment'
import {
  IGetTabRequest,
  ITabDetail,
  ITableEnableResponse,
  ITableIdRequest,
  ITableServiceIdRequest,
} from 'interfaces/tab'
import httpClient from './base-service'

const endPointBaseURL = `/Tabs`
const tableEndPointBaseURL = `/Table`

// Cache object to store payment status responses
const paymentStatusCache: { [key: string]: ITableEnableResponse } = {}

const getTabs = async (
  requestBody: IGetTabRequest
): Promise<AxiosResponse<IApiSuccessResponse<ITabDetail>>> =>
  httpClient.post<IApiSuccessResponse<ITabDetail>>(
    `${endPointBaseURL}/get-tab-order-by-id`,
    requestBody,
    {
      hideLoader: true,
    }
  )

const getIsPaymentEnable = async (
  requestBody: ITableIdRequest
): Promise<AxiosResponse<IApiSuccessResponse<ITableEnableResponse>>> => {
  // Create a cache key from the table ID
  const cacheKey = requestBody.tableId.toString()

  // // Check if we have a cached response
  // if (paymentStatusCache[cacheKey]) {
  //   // Return a mock AxiosResponse with the cached data
  //   return {
  //     data: {
  //       message: 'Success',
  //       data: paymentStatusCache[cacheKey],
  //     },
  //     status: 200,
  //     statusText: 'OK',
  //     headers: {},
  //     config: {} as any,
  //   } as AxiosResponse<IApiSuccessResponse<ITableEnableResponse>>
  // }

  // If no cache, make the API call
  const response = await httpClient.post<
    IApiSuccessResponse<ITableEnableResponse>
  >(
    `${tableEndPointBaseURL}/get-table-payment-status-by-table-id`,
    requestBody,
    {
      hideLoader: true,
    }
  )

  // Cache the response
  if (response.data.data) {
    const responseData = response.data.data as ITableEnableResponse
    paymentStatusCache[cacheKey] = responseData
  }

  return response
}

const setTableStatus = async (
  requestBody: ITableServiceIdRequest
): Promise<AxiosResponse<IApiSuccessResponse<ITableEnableResponse>>> =>
  httpClient.post<IApiSuccessResponse<ITableEnableResponse>>(
    `${tableEndPointBaseURL}/update-out-of-service`,
    requestBody,
    {
      hideLoader: true,
    }
  )

const updateOrders = async (
  requestBody: ITabIdRequest
): Promise<AxiosResponse<IApiSuccessResponse<string>>> =>
  httpClient.post<IApiSuccessResponse<string>>(
    `${endPointBaseURL}/update-orders`,
    requestBody,
    {
      hideLoader: true,
    }
  )

const getCheckPosition = async (
  requestBody: ICheckLockDate
): Promise<AxiosResponse<IApiSuccessResponse<ITabDetail>>> =>
  httpClient.post<IApiSuccessResponse<ITabDetail>>(
    `${endPointBaseURL}/check-order-lock`,
    requestBody
  )

// CheckAnyOrderAvailable function removed - order availability is now determined from tab data

const trackQRScan = async (
  requestBody: ITableIdRequest
): Promise<AxiosResponse<IApiSuccessResponse<string>>> =>
  httpClient.post<IApiSuccessResponse<string>>(
    `${tableEndPointBaseURL}/track-qr-scan`,
    requestBody,
    {
      hideLoader: true,
    }
  )

export default {
  getTabs,
  updateOrders,
  getIsPaymentEnable,
  getCheckPosition,
  setTableStatus,
  trackQRScan,
}
